export default "__VITE_ASSET__BIjzzgCr__"